<style lang="scss" scoped>

    #bottombar{
        width: 100%;
        position: fixed;
        height: auto;
        z-index: 999;
        transition: all .3s;
        border:0;
        z-index:1000;
        display:flex;
        flex-direction: column;
        left:0;
        bottom:-130%;
        transition: all 600ms;

        .content{
            z-index:10;
            background:#e2dcd4;

            .btn-primary{

                &:after{
                    background: linear-gradient(270deg, rgba(238, 233, 229, 0) 0%, #e2dcd4 100%);
                }

            }

        }

        .background-obfuscator{
            position:fixed;
            left:0px;
            top:0;
            width: calc(100%);
            height:100%;
            background:rgba(0, 0, 0, 0.5);
            z-index:-1;
            opacity: 0;
            transition: all 600ms;
            pointer-events: none;
        }

        &.appear{
            bottom:0;
            transition: all 600ms;

            .background-obfuscator{
                pointer-events: all;
                opacity:1;
                transition: all 600ms;
            }

        }

        .free-shipping{
            position: relative;
            width: 100%;
        }

    }

</style>

<template>
    <nav id="bottombar" class="collapse show" :class="show ? 'appear' : ''">
        <div class="h-100 pt-3 pb-4 content">
            <div class="h-100">

                <div class="d-flex flex-column h-100 mt-0">

                    <div class="d-flex w-100 px-4 py-1">
                        <div class="flex-grow-1">
                            <span class="h6 text-primary font-italic">{{$root.translateString('added_to_cart')}}!</span>
                        </div>
                        <div @click="show = false">
                            <img width="17" src="/images/icons/assets-07.svg" alt="chiudi"/>
                        </div>
                    </div>
                    <div class="w-100">
                       <hr>
                    </div>

                    <div class="flex-grow-1 overflow-auto mt-n3">
                        <div class="pt-3 px-4">
                            <div class="w-100 d-flex product-line" v-if="cart != null && last_item != null">
                                <img width="62" height="80" class="ml-n2" :src="last_item.options.image" :alt="last_item.options.name" />
                                <div class="d-flex flex-column flex-grow-1 pl-4">
                                    <div class="d-flex flex-grow-1 pl-0 pt-15 w-100">
                                        <span class="pe-2 h-100 text-nowrap">{{last_item_count}} x</span>
                                        <span class="flex-grow-1 d-flex flex-column">
                                            <span class="text-uppercase" v-text="last_item.options.name.replace('<br>', ' ')"></span>
                                            <span class="w-100 text-grey pt-15" v-if="last_item.options.type == 'vini'" v-text="last_item.options.combination"></span>
                                            <span class="w-100 text-grey pt-15" v-else>Marchesi di Barolo</span>
                                        </span>
                                    </div>
                                    <div class="py-0 d-flex flex-grow-1 mt-2 pl-0">
                                        <p class="flex-grow-1 price text-nowrap mb-0">
                                            € {{ $root.currencyDisplaySimple(parseFloat(last_item.price)) }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="totals px-4">
                        <div class="line d-flex mb-0 mt-2 text-grey">
                            <a :href="$root.langRoute('/carrello')" class="btn d-inline-flex btn-primary pt-25 pb-35 ps-45 ps-sm-5 pe-45 pe-sm-5 mt-4 mt-sm-0 h-auto h7 text-uppercase w-100">
                                <span class="d-block mx-25 mx-lg-0">
                                    <span class="text-smaller-90 text-md-default-size text-smaller-lg-90 text-smaller-xl-95 text-xl-default-size">{{$root.translateString('go_to_cart')}}</span>
                                </span>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="background-obfuscator" @click="show = false"></div>
    </nav>
</template>
<script>
export default {
    props: ['lang', 'freeShippingAt'],
    data() {
        return {
            show:false,
            cartRaw: null,
            priceTotalWt: 0,
            finalPrice: 0,
            shipping: 0,
            discount: 0,
            missing_for_free_shipping: 0,
            last_item: null,
            last_item_id: null,
            last_item_count: null,
        }
    },
    mounted() {
        this.getCart();

        this.$eventHub.$on('cart.show', payload => {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            if(vw <= 575) {
                this.show = true;
            }
        });

        this.$eventHub.$on('cart.added', payload => {
            this.last_item_id = payload.product_id;
            this.last_item_count = payload.specific_count;
            this.getCart();
        });

        this.$eventHub.$on('cart.updated', payload => {
            this.getCart();
        });

    },
    methods: {
        emptyCart() {
            axios.post('/api/cart/empty', {})
            .then(response => {
                this.cart = null;
                this.shipping = 0;
                this.priceTotalWt = 0;
                this.finalPrice = 0;
                this.discount = 0;
                this.missing_for_free_shipping = 0;
            })
        },
        updateCart(key, value) {

            axios.post('/api/cart/update', {
                'key': key,
                'qty': value,
            })
            .then(response => {
                this.getCart();

                let update_type = 'add';
                let quantity_to_track = value;

                if(quantity_to_track == 0) {

                    quantity_to_track = this.cart[key].qty;

                    gtag('event', 'remove_from_cart', {
                        "items": [
                            {
                                'name': this.cart[key].options.name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Marchesi di Barolo',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });


                }else{

                    gtag('event', 'add_to_cart', {
                        "items": [
                            {
                                'name': this.cart[key].name,
                                'id': this.cart[key].id,
                                'price': this.cart[key].options.price,
                                'brand': 'Marchesi di Barolo',
                                'category': this.cart[key].options.type,
                                'variant': this.cart[key].options.combination.toLowerCase(),
                                'quantity': quantity_to_track
                            }
                        ]
                    });

                }

                this.$eventHub.$emit('cart.updated');
                this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));
            })
        },
        getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.cartRaw = response.data.cart;
                this.shipping = response.data.shipping;
                this.priceTotalWt = response.data.priceTotalWt;
                this.finalPrice = response.data.finalPrice;
                this.discount = response.data.discount;
                this.missing_for_free_shipping = response.data.missingForFreeShipping;

                if(_.isEmpty(this.cart)) {
                    this.show = false;
                }else{
                    for (let [key, item] of Object.entries(this.cart)) {
                        if(item.id == this.last_item_id) {
                          this.last_item = item;
                        }
                    };
                }

            })
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.show');
        this.$eventHub.$off('cart.updated');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }
            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }
            return tmp;
        },
        countProducts() {
            if(!this.isNotEmpty(this.cart)) {
                return 0;
            }
            let count = 0;
            for (let [key, item] of Object.entries(this.cart)) {
                count += item.qty;
            };
            return count;
        },
    }
}
</script>
